import { PaymentMethod, YesNo } from '../../utils/enums';
import helperFunctions from '../../utils/helperFunctions';

const createLeadPaymentsData = ({ route, trade, paymentCalculator }) => {
  // Ecom & B&P payments data
  let paymentsData;
  if (route.path && (route.path.includes('e-commerce-v2') || route.path.includes('build-and-price'))) {
    let applyTradeIn = null;
    // Set to false only if there is trade data, but not applied to the payment calculations
    if (paymentCalculator.hasTradeIn === YesNo.NO && trade.updateLeadVehicles.tradein.year) {
      applyTradeIn = false;
    } else if (paymentCalculator.tradeInValue) {
      applyTradeIn = true;
    }
    paymentsData = {
      vehiclePrice: paymentCalculator.vehiclePrice,
      tradeInValue: paymentCalculator.tradeInValue,
      downPayment:
        paymentCalculator.paymentMethod !== PaymentMethod.CASH && paymentCalculator.downPayment
          ? paymentCalculator.downPayment
          : null,
      termInMonths:
        paymentCalculator.paymentMethod !== PaymentMethod.CASH
          ? paymentCalculator[`${paymentCalculator.paymentMethod}PaymentTerm`]
          : null,
      salesTax: paymentCalculator[`${paymentCalculator.paymentMethod}`].salesTax
        ? paymentCalculator[`${paymentCalculator.paymentMethod}`].salesTax.toFixed(2)
        : null,
      luxuryTax: paymentCalculator[`${paymentCalculator.paymentMethod}`].luxuryTax
        ? paymentCalculator[`${paymentCalculator.paymentMethod}`].luxuryTax.toFixed(2)
        : null,
      freight: paymentCalculator.freight ? paymentCalculator.freight : null,
      provincialFees: paymentCalculator.provincialFees ? paymentCalculator.provincialFees : null,
      interestRate:
        paymentCalculator.paymentMethod === PaymentMethod.FINANCE ? paymentCalculator.finance.interestRate : null,
      paymentAmount: paymentCalculator[`${paymentCalculator.paymentMethod}`].paymentAmount
        ? paymentCalculator[`${paymentCalculator.paymentMethod}`].paymentAmount.toFixed(2)
        : null,
      tradeInOwing: paymentCalculator.outstandingTradeInBalance,
      loanAmount:
        paymentCalculator.paymentMethod === PaymentMethod.FINANCE && paymentCalculator.finance.loanAmount
          ? paymentCalculator.finance.loanAmount.toFixed(2)
          : null,
      paymentFrequency: paymentCalculator.paymentMethod !== PaymentMethod.CASH ? paymentCalculator.paymentsAYear : null,
      paymentType: paymentCalculator[`${paymentCalculator.paymentMethod}`].paymentAmount
        ? paymentCalculator.paymentMethod
        : null,
      leaseInfo:
        paymentCalculator.paymentMethod === PaymentMethod.LEASE
          ? {
              dueAtDelivery: paymentCalculator.lease.dueOnDelivery
                ? paymentCalculator.lease.dueOnDelivery.toFixed(2)
                : null,
              downpaymentTax: paymentCalculator.lease.downPaymentTax
                ? paymentCalculator.lease.downPaymentTax.toFixed(2)
                : null,
              residualValue: paymentCalculator.lease.residual,
              annualMileageAllowance: paymentCalculator.mileage,
              moneyFactor: paymentCalculator.lease.moneyFactor,
              totalLeaseAmount: paymentCalculator.lease.leaseAmount
                ? paymentCalculator.lease.leaseAmount.toFixed(2)
                : null,
            }
          : null,
      incentives: {
        preTax: paymentCalculator[`${paymentCalculator.paymentMethod}`].preTaxRebates || [],
        postTax: paymentCalculator[`${paymentCalculator.paymentMethod}`].postTaxRebates || [],
      },
      applyTradeIn,
      calculator: {
        creditRating: helperFunctions.creditGradeBiMap(paymentCalculator.creditScoreUsedForPaymentCalculation),
        creditRatingType: paymentCalculator.creditScoreTypeUsedForPaymentCalculation,
      },
    };
  }
  return Object.freeze(paymentsData);
};

export default createLeadPaymentsData;
